import React, {useEffect, useState} from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {
  GameFouls
} from "./game.fouls.js";
import {GameCompetitorViewModel} from "../../../domain/partial-game/models/game-competitor/game-competitor-view-model";
import {GameScoreText} from "./game.score-text";
import {observer} from 'mobx-react';
import styles from "./game-score.module.scss";
import classNames from "classnames";

export class GameScoreProps extends BaseProps {
  className: String;
  homeCompetitorScoreClassName: String;
  awayCompetitorScoreClassName: String;
  delay: Number;
  homeCompetitor: GameCompetitorViewModel;
  awayCompetitor: GameCompetitorViewModel;
  foulsBonusText: String;
  isSmallView: Boolean;
  competitorScoreContainerClassName: String;
  shouldRenderPossession: Boolean;
}

export const GameScore = observer(({
                                     homeCompetitor,
                                     awayCompetitor,
                                     homeCompetitorScoreClassName,
                                     awayCompetitorScoreClassName,
                                     delay,
                                     foulsBonusText,
                                     className,
                                     isSmallView,
                                     competitorScoreContainerClassName,
                                     shouldRenderPossession,
                                     dividerClassName
                                   }: GameScoreProps) => {

  const [homeScore, setHomeScore] = useState(homeCompetitor.score);
  const [awayScore, setAwayScore] = useState(awayCompetitor.score);

  useEffect(() => {
    let homeScoreTimeoutId = setTimeout(() => setHomeScore(homeCompetitor.score), delay || 0);
    let awayScoreTimeoutId = setTimeout(() => setAwayScore(awayCompetitor.score), delay || 0);

    return () => {
      clearTimeout(homeScoreTimeoutId);
      clearTimeout(awayScoreTimeoutId);
    }
  }, [homeCompetitor.score, awayCompetitor.score, homeCompetitorScoreClassName, awayCompetitorScoreClassName, delay]);

  const homeCompetitorFoulsDotProps = {
    foulsBonusText,
    isSmallView,
    competitor: homeCompetitor,
    isHomeCompetitor: true,
  }

  const awayCompetitorFoulsDotProps = {
    foulsBonusText,
    isSmallView,
    competitor: awayCompetitor
  }

  const homeScoreTextProps = {
    score: homeScore,
    competitor: homeCompetitor,
    shouldRenderPossession,
    isHomeCompetitor: true,
    className: [homeCompetitorScoreClassName, competitorScoreContainerClassName].join(' ')
  }

  const awayScoreTextProps = {
    score: awayScore,
    competitor: awayCompetitor,
    shouldRenderPossession,
    className: [awayCompetitorScoreClassName, competitorScoreContainerClassName].join(' ')
  }

  return (
    <div className={classNames(className, styles.container, {[styles.small_view]: isSmallView})}>
      <GameScoreText {...homeScoreTextProps}/>
      <GameFouls {...homeCompetitorFoulsDotProps}/>
      <div className={dividerClassName}>-</div>
      <GameScoreText {...awayScoreTextProps}/>
      <GameFouls {...awayCompetitorFoulsDotProps}/>
    </div>
  )
});
